
import createHOC from '../../arc/createHOC'
import ProjectsContainer from '../container/ProjectsContainer'

const withProjects = createHOC({
    Container: ProjectsContainer
})
export default withProjects
